import {createDataColumn} from "@onemind-services-llc/ui-components";

export const defaultColumns = [createDataColumn("name"), createDataColumn("description")];

export const columnsList = [
  {display: "Name", value: "name", visible: true},
  {display: "Description", value: "description", visible: true},
];
